import { EssayConfig } from './PhotoEssay'
export const PHOTO_ESSAYS: Array<EssayConfig> = [
    {
        link: 'south-america',
        header: '/img/south-america/DSC02325.jpg',
        title: 'Argentina & Brazil',
        subtitle: 'November 2 - December 2, 2024',
        photos: [
            [
                '/img/south-america/2024-11-15 12.37.17.jpg',
                '/img/south-america/2024-11-11 12.25.07.jpg',
                '/img/south-america/2024-11-15 16.27.44.jpg',
            ],
            [
                '/img/south-america/2024-11-08 10.23.46.jpg',
                '/img/south-america/2024-11-11 21.56.37.jpg',
                '/img/south-america/2024-11-11 22.25.24.jpg',
                '/img/south-america/2024-11-11 23.00.05.jpg',
            ],
            [
                '/img/south-america/DSC01696.jpg',
                '/img/south-america/2024-11-14 10.15.28.jpg',
            ],
            [
                '/img/south-america/DSC01667.jpg',
                '/img/south-america/DSC01682.jpg',
            ],
            [
                '/img/south-america/2024-11-14 18.23.20.jpg',
                '/img/south-america/2024-11-14 18.50.42.jpg',
            ],
            [
                '/img/south-america/DSC01791.jpg',
                '/img/south-america/DSC01758.jpg',
                '/img/south-america/DSC01733.jpg',
            ],
            ['/img/south-america/DSC02237.jpg'],
            [
                '/img/south-america/2024-11-18 16.05.32.jpg',
                '/img/south-america/2024-11-19 14.47.04.jpg',
            ],
            [
                '/img/south-america/DSC02255.jpg',
                '/img/south-america/DSC01876.jpg',
                '/img/south-america/DSC01886.jpg',
                '/img/south-america/DSC02110.jpg',
            ],
            ['/img/south-america/DSC02063.jpg'],
            [
                '/img/south-america/DSC02243.jpg',
                '/img/south-america/DSC01856.jpg',
            ],
            [
                '/img/south-america/DSC01993.jpg',
                '/img/south-america/DSC02026.jpg',
            ],
            [
                '/img/south-america/DSC02335.jpg',
                '/img/south-america/DSC02325.jpg',
            ],
            [
                '/img/south-america/DSC02499.jpg',
                '/img/south-america/DSC02482.jpg',
                '/img/south-america/DSC02436.jpg',
            ],
            [
                '/img/south-america/2024-11-22 19.48.42.jpg',
                '/img/south-america/2024-11-27 11.48.23.jpg',
            ],
            [
                '/img/south-america/DSC02711.jpg',
                '/img/south-america/DSC02778.jpg',
            ],
            [
                '/img/south-america/DSC02765.jpg',
                '/img/south-america/2024-11-23 19.55.03.jpg',
            ],
            [
                '/img/south-america/DSC02889.jpg',
                '/img/south-america/DSC02875.jpg',
            ],
            [
                '/img/south-america/2024-11-25 01.56.15.jpg',
                '/img/south-america/DSC02811.jpg',
            ],
            [
                '/img/south-america/2024-11-24 18.16.02.jpg',
                '/img/south-america/DSC03047.jpg',
            ],
            ['/img/south-america/DSC02981.jpg'],
            [
                '/img/south-america/2024-11-26 08.40.00.jpg',
                '/img/south-america/DSC03092.jpg',
            ],
            ['/img/south-america/DSC03056.jpg'],
            [
                '/img/south-america/2024-11-22 22.45.38.jpg',
                '/img/south-america/2024-11-27 17.28.08.jpg',
            ],
            [
                '/img/south-america/2024-11-30 12.59.02.jpg',
                '/img/south-america/2024-11-30 10.37.08.jpg',
            ],
            [
                '/img/south-america/2024-11-30 19.51.13.jpg',
                '/img/south-america/2024-11-30 18.37.13.jpg',
                '/img/south-america/2024-11-30 18.47.50.jpg',
            ],
        ],
    },
    {
        header: '/img/berlin/cover.jpg',
        link: 'berlin',
        title: 'Berlin',
        subtitle: 'November 23 — December 3, 2023',
        photos: [
            [
                '/img/berlin/walk-1.jpg',
                '/img/berlin/walk-2.jpg',
                '/img/berlin/walk-3.jpg',
            ],
            ['/img/berlin/walk-4.jpg', '/img/berlin/walk-5.jpg'],
            ['/img/berlin/hol-1.jpg'],

            [
                '/img/berlin/hol-2.jpg',
                '/img/berlin/hol-3.jpg',
                '/img/berlin/hol-4.jpg',
            ],

            [
                '/img/berlin/jewish-1.jpg',
                '/img/berlin/jewish-2.jpg',
                '/img/berlin/jewish-3.jpg',
            ],
            ['/img/berlin/syn-1.jpg', '/img/berlin/syn-2.jpg'],

            ['/img/berlin/ham-1.jpg'],

            [
                '/img/berlin/ham-0.jpg',
                '/img/berlin/ham-2.jpg',
                '/img/berlin/ham-3.jpg',
            ],
            [
                '/img/berlin/ham-4.jpg',
                '/img/berlin/ham-5.jpg',
                '/img/berlin/ham-6.jpg',
            ],

            [
                '/img/berlin/doner-1.jpg',
                '/img/berlin/doner-2.jpg',
                '/img/berlin/doner-3.jpg',
            ],
            ['/img/berlin/brian.jpg', '/img/berlin/danny.jpg'],
            ['/img/berlin/group.jpg'],
        ],
    },
]
